<template>
  <div class="notfund-page">
    <!-- <img src="../../assets/404.png" alt=""> -->
    <span class="tips">{{ $t('components.notFoundTips') }}</span>
    <el-button size="small" type="primary" @click="backToHome">{{
      $t('components.notFoundBack')
    }}</el-button>
  </div>
</template>

<script>
import { getFirstRoute } from '@younuo/utils/utils'
export default {
  data() {
    return {}
  },
  methods: {
    backToHome() {
      let path = getFirstRoute(this.$store.state.menus)
      this.$router.replace({ path })
    }
  }
}
</script>
<style lang="less">
.notfund-page {
  text-align: center;
  .tips {
    display: block;
    line-height: 22px;
    margin-bottom: 65px;
    color: #999;
  }
  img {
    margin-top: 240px;
  }
}
</style>
